/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '../base.component';
import { UtilsService } from '../../services';

@Component({
    selector: 'app-action-dots-wrapper',
    template: `
        <div #wrapperContainer id="actions-content">
            <ng-content></ng-content>
        </div>`,
    styleUrls: ['./action-dots-wrapper.component.scss']
})
export class ActionDotsWrapperComponent extends BaseComponent implements AfterViewInit {
    /**
     * Reference to wrapper container.
     * @private
     */
    @ViewChild('wrapperContainer')
    private container: any;

    /**
     * Output clicked action dot.
     */
    @Output() public actionDotsClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(
        private utilsService: UtilsService
    ) {
        super();
    }

    ngAfterViewInit() {
        this.addRequiredClassesToButtonNodes();
    }

    /**
     * Add required classes to all button nodes
     * @private
     */
    private addRequiredClassesToButtonNodes(): void {
        const childNodes = this.utilsService.getObjectValue(this.container, 'nativeElement.childNodes');
        if (childNodes) {
            for (const element of childNodes) {
                if (element.tagName) {
                    if (element.tagName.toLowerCase() === 'button') {
                        this.addRequiredClasses(element);
                    } else if (element.tagName.toLowerCase() === 'app-loading-button') {
                        const nestedButton: any = this.findButtonInLoadingComponent(element);
                        this.addRequiredClasses(nestedButton);
                    }
                }
            }
        }
    }

    /**
     * Add required class
     * @param element
     * @private
     */
    private addRequiredClasses(element: HTMLElement): void {
        const classes = element.classList;

        if (!element.className.includes('menu-item-wrapper')) {
            classes.add('menu-item-wrapper');
        }

        if (!element.className.includes('action-dots-small')) {
            classes.add('action-dots-small');
        }

        if (!element.className.includes(element.innerText)) {
            // Clean up the inner text, so it can be added as a class
            const newClass = element.innerText.trim().toLowerCase().replace(/\s+/g, '-');
            classes.add(newClass);
        }
    }

    /**
     * Find the nested button inside the loading
     * @param element
     * @private
     */
    private findButtonInLoadingComponent(element: HTMLElement): ChildNode {
        const nestedElement: any = element.childNodes[0];
        if (nestedElement?.tagName.toLowerCase() === 'button') {
            return element.childNodes[0];
        }
    }
}
